var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Youku = youbora.Adapter.extend({

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.playhead
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Youku'
  },

  registerListeners: function () {
    this.monitorPlayhead(true, true)
    this.eventListener = this.playerEventParser.bind(this)
    window.addEventListener('message', this.eventListener)
  },

  unregisterListeners: function () {
    window.removeEventListener('message',this.eventListener)
    if (this.monitor) this.monitor.stop()
  },

  playerEventParser: function (e) {
    if (e && e.data){
      switch(e.data.msg){
        case 'onPlayStart':
          this.startListener()
          break
        case 'onTimeUpdate':
          this.timeUpdateListener(e.data)
          break
        case 'onPlayEnd':
          this.endedListener()
          break
        case 'state':
          this.stateChange(e.data)
          break
      }
    }
  },

  stateChange: function(e){
    if (e && e.stateParam){
      switch (e.stateParam){
        case 'play':
          this.resumeListener()
          break
        case 'pause':
          this.pauseListener()
          break
      }
    }
  },

  timeUpdateListener: function (e){
    if (this.flags.isStarted && e && e.time > 0){
      this.playhead = e.time
      this.fireJoin()
    }
  },

  startListener: function () {
    this.fireStart()
  },

  pauseListener: function () {
    this.firePause()
  },

  resumeListener: function () {
    this.fireResume()
  },

  endedListener: function () {
    this.fireStop()
  }
})

module.exports = youbora.adapters.Youku
